import axios from '@axios'

const route = 'helper'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getHelp(context, help) {
      return axios.post(`${route}/get_help/${help}`)
    },
  },
}
